import { render, staticRenderFns } from "./CompleteRelativeUser.vue?vue&type=template&id=9d2fda54&"
import script from "./CompleteRelativeUser.vue?vue&type=script&lang=js&"
export * from "./CompleteRelativeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports